exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "pre[data-v-833ab9bc]{white-space:pre-wrap;word-wrap:break-word}", ""]);

// exports
